import { Field } from 'react-final-form';
import { Flex, FormField, FormHelp, IconWarning, Input, Label, Paragraph } from '@zillow/constellation';
import { FieldValidator, lettersAndSpacesOnly, lettersAndSpacesOnlyErrorText } from '../../../validation/validation';
import { MIDDLE_NAME } from '../../../constants/formFieldNames';

export default function MiddleNameField() {
  return (
    <Field
      name={MIDDLE_NAME}
      format={(middleName) => middleName?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);

        return (
          <FormField
            error={isInvalid}
            label={<Label>Legal middle name</Label>}
            control={<Input {...input} />}
            description={
              isInvalid ? (
                <FormHelp>{error}</FormHelp>
              ) : !input?.value ? (
                // @ts-ignore
                <Flex display="flex" marginTop="xxs">
                  <IconWarning marginRight="xs" fontColor="orange500" />
                  <Paragraph fontType="finePrint" fontColor="orange500">
                    This field is used to match to your identity. If you have a legal middle name, enter it to ensure
                    that an accurate credit & background report is returned.
                  </Paragraph>
                </Flex>
              ) : null
            }
          />
        );
      }}
      validate={(middleName) => {
        const errors = new FieldValidator(middleName)
          .maxLength(32)
          .regex(lettersAndSpacesOnly, lettersAndSpacesOnlyErrorText)
          .build();

        return errors ? errors : null;
      }}
    />
  );
}
